import type { ShiftEditorDraftEndpoint } from '@der-maschinfuehrer/contracts';
import { forwardRef, type ComponentProps } from 'react';

import type { CatalogClient } from '../../catalog/catalog-client';
import { CatalogAutocompleteField } from './CatalogAutocompleteField';

type CatalogDocument = Parameters<ComponentProps<typeof CatalogAutocompleteField>['onSelect']>[0];

export const DraftEndpointField = forwardRef<
  HTMLInputElement,
  {
    readonly client: CatalogClient;
    readonly disabled: boolean;
    readonly endpoint: ShiftEditorDraftEndpoint | null;
    readonly fallbackCountry?: 'CZ' | 'DE';
    readonly label: string;
    readonly name: string;
    readonly onManualChange: (value: {
      readonly country_code: 'CZ' | 'DE';
      readonly name: string;
    }) => void;
    readonly onSelect: (document: CatalogDocument) => void;
    readonly required: boolean;
  }
>(function DraftEndpointField(
  {
    client,
    disabled,
    endpoint,
    fallbackCountry = 'CZ',
    label,
    name,
    onManualChange,
    onSelect,
    required,
  },
  ref,
) {
  const country = endpoint?.country_code ?? fallbackCountry;
  const value = endpoint?.name ?? '';
  return (
    <fieldset disabled={disabled}>
      <legend>Provozní místo {label}</legend>
      <CatalogAutocompleteField
        ref={ref}
        client={client}
        disabled={disabled}
        label={label}
        name={`${name}-name`}
        required={required}
        value={value}
        onChange={(nameValue) => onManualChange({ country_code: country, name: nameValue })}
        onSelect={onSelect}
      />
      <label className="form-field">
        <span>Země místa {label}</span>
        <select
          className="text-input touch-target"
          disabled={disabled}
          name={`${name}-country`}
          value={country}
          onChange={(event) =>
            onManualChange({
              country_code: event.currentTarget.value as 'CZ' | 'DE',
              name: value,
            })
          }
        >
          <option value="CZ">Česko</option>
          <option value="DE">Německo</option>
        </select>
      </label>
    </fieldset>
  );
});
